var _ellipse, _path, _path2, _rect, _path3, _path4, _circle, _circle2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessApi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05176 20.5H10.6553V15.0771C10.6553 14.1719 11.1387 13.5127 12.0352 13.5127C12.9404 13.5127 13.415 14.1104 13.415 15.0859V20.5H17.0186V14.2861C17.0186 11.957 15.8408 10.6035 13.6611 10.6035C12.1846 10.6035 11.1211 11.3418 10.6377 12.7041H10.5674V7.81738H7.05176V20.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.1399,
    y: 18.1035,
    width: 3.83912,
    height: 9.39905,
    rx: 1.91956,
    transform: "rotate(60 31.1399 18.1035)",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0217 23.9648L30.0217 20.9648",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5837 14.866C34.3076 14.3877 33.696 14.2239 33.2177 14.5L30.3534 16.1537C30.2432 16.2173 30.1462 16.3014 30.0675 16.4013L28.9402 17.834C28.6874 18.1553 28.6556 18.5982 28.8601 18.9524L31.183 22.9759C31.3875 23.33 31.787 23.5239 32.1917 23.4656L33.996 23.2057C34.1219 23.1875 34.2432 23.1455 34.3534 23.0819L37.2177 21.4282C37.696 21.1521 37.8599 20.5405 37.5837 20.0622L34.5837 14.866ZM32.6196 19.4641C32.8958 19.9424 33.5074 20.1063 33.9857 19.8301C34.464 19.554 34.6278 18.9424 34.3517 18.4641C34.0755 17.9858 33.464 17.8219 32.9857 18.0981C32.5074 18.3742 32.3435 18.9858 32.6196 19.4641Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 6,
    r: 3.5,
    stroke: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 3.5,
    stroke: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14V14C18 12.3431 19.3431 11 21 11H23H25C26.6569 11 28 12.3431 28 14V14",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16V16C27 14.3431 28.3431 13 30 13H32H34C35.6569 13 37 14.3431 37 16V16",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessApi);
export default __webpack_public_path__ + "static/media/Access API.672d45fcf2c03c46913c06586c4fc70e.svg";
export { ForwardRef as ReactComponent };